/** @format */

import {format} from 'date-fns';

import {ru} from 'date-fns/locale';

import * as R from 'ramda';

import {reportLink} from 'helpers/reportHelpers';

import {getDateArray} from 'helpers/dateHelpers';

import {YalperPlatform} from 'graphql/generated/types';

import {filterPlatformsByTokens} from 'helpers/adTypeHelpers';

import {LastCheckType, ReportFileFormat, ReportTableRowData} from '../types';
import {ALL_FILE_FORMATS} from '../constants';
import {GetCurrentUserQueryPage} from '../graphql/__generated__';

export interface MapTableDataOptions {
  data: GetCurrentUserQueryPage;
  platforms: YalperPlatform[];
  startDate: Date;
  endDate: Date;
}

const mapTableData = ({
  data,
  platforms,
  endDate,
  startDate,
}: MapTableDataOptions): ReportTableRowData[] => {
  if (!data?.currentUser?.currentCompany) {
    return [];
  }

  const allDates = getDateArray({
    startDate,
    endDate,
    format: 'yyyy-MM-dd',
  });

  allDates.sort((a, b) => b.localeCompare(a));

  const {uuid, sensorExclusions, lastChecks, tokens} = data.currentUser.currentCompany;

  const allSensors = R.pipe(
    R.map((v: LastCheckType) => v.sensor.name),
    R.without(sensorExclusions.map(v => v.sensorName)),
  )(lastChecks);

  const filteredPlatforms = filterPlatformsByTokens(tokens, platforms);

  return allDates.map(date => {
    const formats: Record<ReportFileFormat, string> = {
      pdf: '',
      html: '',
      xlsx: '',
    };

    ALL_FILE_FORMATS.forEach(fileFormat => {
      formats[fileFormat] = reportLink(
        data.currentUser?.uuid || '',
        uuid,
        date,
        allSensors.join(','),
        filteredPlatforms.join(','),
        fileFormat,
        data.currentUser?.lang || 'RU',
      );
    });

    return {
      date: format(date, 'd MMMM yyyy', {locale: ru}),
      pdfUrl: formats.pdf,
      htmlUrl: formats.html,
      xlsxUrl: formats.xlsx,
    };
  });
};

export {mapTableData};
